module.exports = __webpack_public_path__ + "static/media/shopping-basket.d49bbb81.svg";